import { Injectable, NgZone, OnDestroy } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class SignalRService implements OnDestroy {
  private hubConnection: signalR.HubConnection | null = null;
  private messageSubject = new Subject<void>();

  readonly newMessage$ = this.messageSubject.asObservable();

  constructor(private ngZone: NgZone) {}

  connect(personId: string): void {
    if (this.hubConnection) return;

    // Run outside Angular zone so SignalR's reconnect timers don't keep
    // change detection permanently active across the whole app.
    this.ngZone.runOutsideAngular(() => {
      this.hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${environment.baseURL}hubs/notifications`)
        .withAutomaticReconnect()
        .build();

      // Re-enter zone only for the event that Angular needs to react to.
      this.hubConnection.on('NewMessage', () =>
        this.ngZone.run(() => this.messageSubject.next())
      );

      this.hubConnection.start()
        .then(() => this.hubConnection!.invoke('JoinPersonGroup', personId))
        .catch(err => console.error('SignalR connection error:', err));
    });
  }

  disconnect(): void {
    if (!this.hubConnection) return;
    this.hubConnection.stop();
    this.hubConnection = null;
  }

  ngOnDestroy(): void {
    this.disconnect();
  }
}
